import { Component, OnDestroy, OnInit } from '@angular/core';
import { IOrganisation } from '@bciti/types';
import { Store } from '@ngrx/store';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { State } from 'src/app/store';
import { organisationsLoadingSelector, organisationsSelector } from 'src/app/store/global/global.selectors';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject();
    private update$ = new ReplaySubject();

    organisations: Partial<IOrganisation>[];

    isLoading$: Observable<Boolean> = this.store.select(organisationsLoadingSelector).pipe(
        takeUntil(this.destroy$),
        map((loading) => loading),
    );

    constructor(private store: Store<State>) {}

    ngOnInit(): void {
        this.store
            .select(organisationsSelector)
            .pipe(
                takeUntil(this.destroy$),
                map((organisations) => {
                    this.organisations = organisations.data;
                }),
            )
            .subscribe();
    }

    getOrganisations() {
        this.update$.next();
    }

    get organisationLength() {
        return this.organisations.length;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
